export default __webpack_public_path__ + "static/media/edit_resume.396b0b1e.png";